import React, { ReactNode } from 'react';

import styled from 'styled-components';

import UIButton, { EUIButtonVariant } from '@aquariuxfintech/aqx-trader-react-ui/button';
import { ESpacing, ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';

interface IAuthCompletedContentProps {
  header: string;
  onClickPrimaryButton: () => void;
  primaryButtonText: string;
  primaryButtonDataTestId: EDataTestId;
  description?: string;
  descriptionNode?: ReactNode;
  extraContent?: ReactNode;
  secondaryButtonText?: string;
  secondaryButtonDataTestId?: EDataTestId;
  onClickSecondaryButton?: () => void;
}

const AuthCompletedContent: FCC<IAuthCompletedContentProps> = ({
  header,
  description,
  onClickPrimaryButton,
  primaryButtonText,
  extraContent,
  descriptionNode,
  secondaryButtonText,
  onClickSecondaryButton,
  primaryButtonDataTestId,
  secondaryButtonDataTestId
}) => {
  return (
    <StyledContainer>
      <StyledHeader typography={ETypography.DISPLAY_M_BOLD}>{header}</StyledHeader>
      {descriptionNode || <StyledDescription typography={ETypography.TEXT_XL_REGULAR}>{description}</StyledDescription>}
      {extraContent}
      <StyledButtonGroupContainer>
        <StyledButtonContainer>
          <UIButton
            variant={EUIButtonVariant.FILLED_THEMED}
            stretch={true}
            onClick={onClickPrimaryButton}
            dataTestId={primaryButtonDataTestId}
            size="large"
            uppercase={false}
          >
            {primaryButtonText}
          </UIButton>
        </StyledButtonContainer>
        {secondaryButtonText && (
          <StyledButtonContainer>
            <UIButton
              variant={EUIButtonVariant.OUTLINED_THEMED}
              stretch={true}
              onClick={onClickSecondaryButton}
              dataTestId={secondaryButtonDataTestId}
              size="large"
              uppercase={false}
            >
              {secondaryButtonText}
            </UIButton>
          </StyledButtonContainer>
        )}
      </StyledButtonGroupContainer>
    </StyledContainer>
  );
};

export default AuthCompletedContent;

const StyledHeader = styled(UIText)`
  text-align: center;
  margin-bottom: ${ESpacing.REGULAR}px;
`;

const StyledDescription = styled(UIText)`
  text-align: center;
  color: ${({ theme }) => theme.themeColors.text.subtle};
`;

const StyledContainer = styled.div`
  width: 512px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const StyledButtonContainer = styled.div`
  display: flex;
`;

const StyledButtonGroupContainer = styled.div`
  margin-top: ${ESpacing.XXL}px;
  display: flex;
  flex-direction: column;
  gap: ${ESpacing.M}px;
`;
